module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p9"
    }
  }), _vm._v(" Kathy Austin's Nutty French Toast")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("\"This is a great twist to the traditional French toast,\" says Kathy Austin from Houston, Texas. \"It has a nutty texture and lots of protein! Great for those cold mornings before heading out on the road!\" Well, once you whip up a batch of these, you will be nuts about them too. What a great way to start the day before a winter's ride on your Harley.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "id": "p10"
    }
  }), _vm._v(" "), _c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("large eggs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup milk")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Granulated sugar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Crushed nuts (almonds, pecans, cashews, etc.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Ground cinnamon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Ground nutmeg")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Sliced bread (white or wheat, the thicker the better) ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Butter (for cooking and to put on after cooking) ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Confectioners' sugar (optional) ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Syrup (optional)")])])])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("In a large shallow bowl, mix the eggs and milk together well. Add granulated sugar, crushed nuts, cinnamon, and nutmeg to your taste.")]), _vm._v(" "), _c('li', [_vm._v("Heat a large nonstick skillet (Silverstone or Teflon) over medium heat and melt some butter to cover the bottom or coat with nonstick cooking spray.")]), _vm._v(" "), _c('li', [_vm._v("Place several slices of bread in the egg mixture and coat on both sides, letting the excess drip off a bit.")]), _vm._v(" "), _c('li', [_vm._v("Lay the bread in the skillet and cook on both sides until golden brown.")]), _vm._v(" "), _c('li', [_vm._v("Serve with butter, sprinkle with confectioners' sugar, if desired, and serve with syrup, if desired.")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MAKES")]), _vm._v(" 4 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("TO")]), _vm._v(" 6 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("SERVINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('img', {
    staticClass: "art",
    attrs: {
      "alt": "[Image]",
      "id": "fig_BikerBillysHogWildOnAHarleyCookbook-26",
      "src": "images/BikerBillysHogWildOnAHarleyCookbook-26.jpg",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('b', [_c('em', [_vm._v("Kathy Austin's 1995 883 Sporty")])])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26481a34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c007.vue
// module id = 99
// module chunks = 0